import AppConstants from '../config/app.constants';

let VehicleLockerService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/vehicle-locker`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getLockerLocations = (locationIds, searchText, branchId, limit, offset) => {
        return $http
            .post(AppConstants.api + `/vehicle-locker/get-locker-locations`, {
                locationIds,
                searchText,
                branchId,
                limit,
                offset
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        getLockerLocations
    };
};

VehicleLockerService.$inject = ['$http', '$q']

export default VehicleLockerService;


// WEBPACK FOOTER //
// ./client/app/services/vehicle-lockers.service.js